import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Collapse, Form, Row } from '@themesberg/react-bootstrap';
import moment from 'moment-timezone';
import { Context } from '../Reward';

export default function FilterForm() {
  const { state, dispatch } = useContext(Context);
  const [expanded, setExpanded] = useState(false);
  const [draft, setDraft] = useState({});

  useEffect(() => {
    setDraft({
      from: state.filter.from ? moment(state.filter.from).format('YYYY-MM-DD') : '',
      to: state.filter.to ? moment(state.filter.to).format('YYYY-MM-DD') : '',
      phone: state.filter.phone,
      gameId: state.filter.gameId,
      minReward: state.filter.minReward,
      maxReward: state.filter.maxReward
    });
  }, [state.filter.from, state.filter.to, state.filter.phone, state.filter.gameId, state.filter.minReward, state.filter.maxReward, state.filter.gameScope]);

  const update = (key, value) => setDraft(current => ({ ...current, [key]: value }));
  const submit = event => {
    event.preventDefault();
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: { ...draft, gameId: state.filter.gameScope === 'other' ? draft.gameId || '' : '' }
    });
  };
  const reset = () => dispatch({
    type: 'SUBMIT_FILTER',
    payload: { from: new Date(), to: new Date(), phone: '', gameId: '', minReward: '', maxReward: '' }
  });

  const gameLabel = state.filter.gameScope === 'keno'
    ? 'Keno'
    : state.games.find(game => game.id === state.filter.gameId)?.name || 'Tất cả trò chơi ngoài Keno';
  const rewardRange = state.filter.minReward || state.filter.maxReward
    ? `Giải: ${Number(state.filter.minReward || 0).toLocaleString('vi-VN')} – ${state.filter.maxReward ? Number(state.filter.maxReward).toLocaleString('vi-VN') : 'không giới hạn'}`
    : '';

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header className="bg-white p-0">
        <button
          type="button"
          className="w-100 border-0 bg-transparent px-3 py-2 text-start d-flex align-items-center justify-content-between flex-wrap gap-2"
          aria-expanded={expanded}
          aria-controls="reward-search-fields"
          onClick={() => setExpanded(value => !value)}
        >
          <div className="d-flex align-items-center flex-wrap gap-2">
            <strong>Bộ lọc</strong>
            <Badge bg="light" text="dark">{moment(state.filter.from).format('DD/MM/YYYY')} – {moment(state.filter.to).format('DD/MM/YYYY')}</Badge>
            <Badge bg="light" text="dark">{gameLabel}</Badge>
            {state.filter.phone && <Badge bg="light" text="dark">SĐT: {state.filter.phone}</Badge>}
            {rewardRange && <Badge bg="light" text="dark">{rewardRange}</Badge>}
          </div>
          <span className="text-primary text-nowrap">{expanded ? 'Thu gọn bộ lọc ▴' : 'Mở rộng bộ lọc ▾'}</span>
        </button>
      </Card.Header>
      <Collapse in={expanded}>
        <div id="reward-search-fields">
          <Form onSubmit={submit}>
            <Card.Body className="p-3">
              <Row className="g-2">
                {state.filter.gameScope === 'other' && (
                  <Col md={6} xl={3}>
                    <Form.Label className="small mb-1">Trò chơi</Form.Label>
                    <Form.Select size="sm" value={draft.gameId || ''} onChange={event => update('gameId', event.target.value)}>
                      <option value="">Tất cả trò chơi ngoài Keno</option>
                      {state.games.filter(game => game.id !== 'keno').map(game => <option key={game.id} value={game.id}>{game.name}</option>)}
                    </Form.Select>
                  </Col>
                )}
                <Col md={6} xl={3}>
                  <Form.Label className="small mb-1">Số điện thoại</Form.Label>
                  <Form.Control size="sm" value={draft.phone || ''} onChange={event => update('phone', event.target.value)} placeholder="Nhập số điện thoại" />
                </Col>
                <Col md={6} xl={3}>
                  <Form.Label className="small mb-1">Giải thưởng từ</Form.Label>
                  <Form.Control size="sm" type="number" min="0" value={draft.minReward || ''} onChange={event => update('minReward', event.target.value)} placeholder="0" />
                </Col>
                <Col md={6} xl={3}>
                  <Form.Label className="small mb-1">Giải thưởng đến</Form.Label>
                  <Form.Control size="sm" type="number" min="0" value={draft.maxReward || ''} onChange={event => update('maxReward', event.target.value)} placeholder="Không giới hạn" />
                </Col>
                <Col md={6} xl={3}>
                  <Form.Label className="small mb-1">Từ ngày</Form.Label>
                  <Form.Control size="sm" type="date" value={draft.from || ''} onChange={event => update('from', event.target.value)} />
                </Col>
                <Col md={6} xl={3}>
                  <Form.Label className="small mb-1">Đến ngày</Form.Label>
                  <Form.Control size="sm" type="date" value={draft.to || ''} onChange={event => update('to', event.target.value)} />
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className="bg-white p-2 d-flex justify-content-end gap-2">
              <Button size="sm" variant="outline-secondary" type="button" onClick={reset}>Xóa bộ lọc</Button>
              <Button size="sm" variant="info" type="submit" disabled={state.isFilterLoading}>
                {state.isFilterLoading ? 'Đang tải...' : 'Áp dụng bộ lọc'}
              </Button>
            </Card.Footer>
          </Form>
        </div>
      </Collapse>
    </Card>
  );
}
